var map = {
	"./asc.avif": 38,
	"./cudu.avif": 5806,
	"./dafz.avif": 1326,
	"./desc.avif": 3868,
	"./fanr.avif": 4704,
	"./masdar.avif": 1351,
	"./png/asc.png": 9624,
	"./png/cudu.png": 2486,
	"./png/dafz.png": 602,
	"./png/desc.png": 3224,
	"./png/fanr.png": 5100,
	"./png/masdar.png": 8413,
	"./png/rabdan.png": 6979,
	"./png/titan.png": 2701,
	"./png/uaeu.png": 6411,
	"./png/zau.png": 6883,
	"./rabdan.avif": 7594,
	"./titan.avif": 2453,
	"./uaeu.avif": 9049,
	"./zau.avif": 7147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 403;